import React from "react";
import { useOverrides, Override } from "@quarkly/components";
import { Image, LinkBox, Link, Box, Section } from "@quarkly/widgets";
import QuarklycommunityKitMobileSidePanel from "./QuarklycommunityKitMobileSidePanel";
const defaultProps = {
	"padding": "18px 0 18px 0",
	"quarkly-title": "Header",
	"box-shadow": "--m"
};
const overrides = {
	"linkBox": {
		"kind": "LinkBox",
		"props": {
			"href": "/index"
		}
	},
	"image": {
		"kind": "Image",
		"props": {
			"max-height": "80px",
			"width": "100%",
			"height": "auto",
			"lg-max-width": "150px",
			"sm-width": "50%",
			"src": "https://uploads.quarkly.io/67604c2fe5d27700189a24f0/images/Plant-Up.png?v=2024-12-16T16:23:23.563Z"
		}
	},
	"quarklycommunityKitMobileSidePanel": {
		"kind": "QuarklycommunityKitMobileSidePanel",
		"props": {
			"width": "50%"
		}
	},
	"quarklycommunityKitMobileSidePanelOverride": {
		"kind": "Override",
		"props": {
			"slot": "Button Text",
			"lg-display": "none"
		}
	},
	"quarklycommunityKitMobileSidePanelOverride1": {
		"kind": "Override",
		"props": {
			"slot": "Button Icon",
			"size": "32px"
		}
	},
	"box": {
		"kind": "Box",
		"props": {
			"display": "flex",
			"justify-content": "center",
			"align-items": "center",
			"md-flex-direction": "column",
			"font": "600 28px/1.3 --fontFamily-googleManrope"
		}
	},
	"link": {
		"kind": "Link",
		"props": {
			"lg-margin": "0px 6px 0px 6px",
			"text-decoration-line": "initial",
			"color": "--dark",
			"font": "--lead",
			"padding": "6px 6px 6px 6px",
			"margin": "0px 18px 0px 18px",
			"md-margin": "0px 18px 10px 18px",
			"href": "/index",
			"children": "Homepage"
		}
	},
	"link1": {
		"kind": "Link",
		"props": {
			"font": "--lead",
			"padding": "6px 6px 6px 6px",
			"margin": "0px 18px 0px 18px",
			"md-margin": "0px 18px 10px 18px",
			"lg-margin": "0px 6px 0px 6px",
			"text-decoration-line": "initial",
			"color": "--dark",
			"href": "/faq",
			"children": "FAQ"
		}
	},
	"link2": {
		"kind": "Link",
		"props": {
			"text-decoration-line": "initial",
			"color": "--dark",
			"font": "--lead",
			"padding": "6px 6px 6px 6px",
			"margin": "0px 18px 0px 18px",
			"lg-margin": "0px 6px 0px 6px",
			"href": "/contacts",
			"children": "Contacts"
		}
	},
	"link3": {
		"kind": "Link",
		"props": {
			"text-decoration-line": "initial",
			"color": "--light",
			"font": "--lead",
			"hover-opacity": "0.9",
			"background": "--color-indigo",
			"border-radius": "8px",
			"padding": "11px 24px 12px 24px",
			"href": "/contacts",
			"md-display": "none",
			"children": "Contact Us"
		}
	}
};

const Header3 = props => {
	const {
		override,
		children,
		rest
	} = useOverrides(props, overrides, defaultProps);
	return <Section {...rest}>
		<Override slot="SectionContent" justify-content="space-around" flex-direction="row" align-items="center" />
		<LinkBox {...override("linkBox")}>
			<Image {...override("image")} />
		</LinkBox>
		<QuarklycommunityKitMobileSidePanel {...override("quarklycommunityKitMobileSidePanel")}>
			<Override {...override("quarklycommunityKitMobileSidePanelOverride")} />
			<Override {...override("quarklycommunityKitMobileSidePanelOverride1")} />
			<Box {...override("box")}>
				<Link {...override("link")} />
				<Link {...override("link1")} />
				<Link {...override("link2")} />
			</Box>
		</QuarklycommunityKitMobileSidePanel>
		<Link {...override("link3")} />
		{children}
	</Section>;
};

Object.assign(Header3, { ...Section,
	defaultProps,
	overrides
});
export default Header3;